/* eslint-disable no-restricted-globals */
/* eslint-disable no-lonely-if */
import React, { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../../store/AuthContext';
import { GtmManager } from '../../utils/GtmManager';
import { StorageHelper } from '../../utils/StorageHelper';
import routerLoader from '../../i18n/router';
import { useAppStore } from '../../store/AppContext';
import { IPManager } from '../../utils/IPManager';

interface Props {
  text: string;
  upperLevelText?: string;
  url?: string;
  title?: string;
  className?: string;
  openInNewWindow?: boolean;
  setShowMiCuenta: (showCuenta: boolean) => void;
  setIsClicked: (click: boolean) => void;
}

const DropdownLink: FC<Props> = ({
  text,
  upperLevelText,
  url,
  openInNewWindow,
  className,
  setShowMiCuenta,
  setIsClicked,
}) => {
  const dataApp = useAppStore();
  const dataUser = useAuthStore();

  const [ipValue, setIpValue] = useState('' as string);

  const sendCloseSessionGtm = async () => {
    const path = window.location.pathname.split('/');
    const fromUrl = routerLoader.LoadRouterByPath(path[2], dataApp.lang);
    const isApp = dataUser.user.isApp === 'true';
    const fromApp = isApp ? 'app_club' : 'web';
    StorageHelper.removeSessionVars();
    GtmManager.sendLogoutGTM(dataUser, dataApp, fromUrl, fromApp, ipValue);
    return true;
  };

  const sendMenuGTM = () => {
    if (upperLevelText) {
      GtmManager.sendMenuLinkClickGTM(`${upperLevelText}-${text}`);
    } else {
      GtmManager.sendMenuLinkClickGTM(text);
    }
  };

  const menuItemRedirect = () => {
    if (url !== undefined) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.getElementById(url).click();
    }
  };

  useEffect(() => {
    if (dataUser.user.email !== '') {
      IPManager.getMyIp(setIpValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser.user.email]);

  const clickIconClose = () => {
    const iconClose = document.querySelector('.menu-buttom') as HTMLElement;
    if (iconClose !== null) {
      iconClose.click();
    }
  };

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
      <li
        className={`dropdown-menu--item  ${className}`}
        onClick={menuItemRedirect}
      >
        {' '}
        <Link
          id={url}
          to={(location) => {
            if (url?.includes('rest/logout')) {
              return { ...location, pathname: '' };
            }
            const l = location;
            l.search = '';
            return { ...l, pathname: url };
          }}
          target={openInNewWindow ? '_blank' : ''}
          onClick={async () => {
            if (url?.includes('rest/logout')) {
              await sendCloseSessionGtm();
              await new Promise((resolve) => setTimeout(resolve, 1000));
              dataApp.closeSession();
            } else if (
              location !== undefined &&
              url &&
              location.pathname === url
            ) {
              sendMenuGTM();
              if (
                url?.includes('tarjetas') &&
                StorageHelper.isForzeSinTarjetas()
              ) {
                StorageHelper.removeForzeSinTarjetas();
                // eslint-disable-next-line no-self-assign
                window.location = window.location;
                if (document.body.classList.contains('fix'))
                  document.body.classList.remove('fix');
              } else {
                setIsClicked(true);
                setShowMiCuenta(false);
              }
            }
            clickIconClose();
          }}
        >
          {text}
        </Link>
      </li>
    </>
  );
};

export default DropdownLink;
